import oneVisionShopSvg from "@/assets/one-vision-shop-ico.svg?raw";
import { t, getValueWithFallback } from "../labelHelpers";
import type { PdfContext } from "../types";

// Construye el header del PDF. Se invoca por pdfmake en cada página con
// (currentPage, pageCount), pero ambos parámetros no se usan en el diseño actual.
export function buildHeader(ctx: PdfContext) {
  const pedido = ctx.pedido;
  const bapi = pedido?.oClaseBAPI;

  // Referencia: `CABIN` es un accesor que solo puebla la respuesta del servidor.
  // El formulario la escribe en `listCABIN` (mapCabeceraToBAPI) y, mientras no
  // se dispare un `preparePedido` — teclear la referencia no lo dispara —, solo
  // está en el store del pedido en curso. De ahí los tres escalones.
  const referencia = getValueWithFallback(
    bapi?.listCABIN?.clsZES_CAB_INPUT?.[0]?.REF_CLIENT ??
      bapi?.CABIN?.REF_CLIENT ??
      bapi?.REF_PEDIDO,
    ctx.pedidosStore.referencia,
  );

  return () => ({
    margin: [30, 5, 28, 0],
    fontSize: 8,
    columns: [
      {
        text: `${t("n_pedido")}:  ${(pedido?.oClaseBAPI?.CABOUT?.VBELN ?? "").replace(/^0+/, "")}`,
        bold: true,
        margin: [0, 18, 0, 0],
        alignment: "left",
      },
      {
        text: `${t("referencia")}:  ${referencia}`,
        margin: [0, 18, 0, 0],
      },
      {
        text: `${t("fecha")}:  ${new Date().toLocaleDateString("es-ES") ?? ""}`,
        alignment: "center",
        width: "auto",
        margin: [0, 18, 15, 0],
      },
      {
        text: `${t("cliente")}:  ${pedido?.oClaseBAPI?.CLIENTE ?? ""}`,
        alignment: "center",
        width: "auto",
        margin: [0, 18, 15, 0],
      },
      // {
      //   text: [
      //     { text: "One ", bold: true },
      //     { text: "Stop", bold: false },
      //   ],
      //   fontSize: 18,
      //   color: "#000000",
      //   alignment: "right",
      //   margin: [15, 5, 35, 0],
      // },
      {
        svg: oneVisionShopSvg,
        width: 80,
        height: 28,
        alignment: "right",
        margin: [0, 2, 5, 0],
      },
    ],
    columnGap: 10,
  });
}
